import { render, staticRenderFns } from "./form-common.vue?vue&type=template&id=c8179394"
import script from "./form-common.vue?vue&type=script&lang=js"
export * from "./form-common.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports